import { memo } from "react";
import Link from "next/link";

import { City } from "@/custom-types/CitiesNearMe";

import CityCard from "../CityCard/CityCard";

type CitiesNearbyProps = {
  cities: City[];
};

const CitiesNearby = ({ cities }: CitiesNearbyProps) => {
  return (
    <div>
      {cities.length > 0 && (
        <div className="container">
          <h2 className="mb-lg">
            Shop for cannabis products in a city near you
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-md">
            {cities.map((city, idx) => (
              <CityCard cityData={city} key={idx} />
            ))}
          </div>
          <div className="pt-md">
            <Link className="text-xs underline" href={"/shop/locations"}>
              See all shop locations
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(CitiesNearby);
